import React from 'react';
import { Col, Form, FormGroup, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button } from 'reactstrap';
import { ModalButtonCancel } from '../../constant';

export const FormService = (props) => {

    const {
        toggle, loading, handleInputChange, validaciones, methodAction, name, button
    } = props;

    const {
        name_valid
    } = validaciones;

    return (
        <Form className="" role="form" onSubmit={methodAction}>
            <div className='form-section'>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label style={{ fontWeight: "600", color: "#374151", marginBottom: "8px" }} >
                                Nombre del servicio <span style={{ color: "#46AFE5" }}> *</span>
                            </Label>

                            <Input
                                type="text"
                                name="name"
                                onChange={handleInputChange}
                                value={name}
                                autoComplete="off"
                                invalid={name_valid}
                                placeholder="Ej. Transporte refrigerado"
                                style={{
                                    borderRadius: "14px",
                                    minHeight: "40px",
                                    border: "1px solid #dbe4f0",
                                    paddingLeft: "15px",
                                    fontSize: "14px",
                                    boxShadow: "none"
                                }}
                            />
                            <FormFeedback>Debe contener 3 o más caracteres</FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
           
        </Form>
    )
}
